import { createSelector } from 'reselect'
import { sessionTypeNames } from 'helpers/enums/sessionTypes'
import getLessonTitleSelector from 'redux/selectors/lessons/lesson_title_selector'

const interactiveVideoSelector = state => state.interactiveVideo

export default createSelector(
	[interactiveVideoSelector, getLessonTitleSelector],
	(interactiveVideo, getLessonTitle) => {
		const title = getLessonTitle(interactiveVideo.lessonUid)
		return {
			isInteractiveMode: interactiveVideo.settings.isInteractiveMode,
			sessionType: sessionTypeNames[interactiveVideo.sessionType],
			title,
		}
	}
)
